<template>
    <div class="auth-step">
        <h1 class="app-typography-title-1 auth-step__title">Select your role</h1>

        <div class="auth-step__role-options" role="radiogroup" aria-label="Select your role">
            <button
                v-for="role in AUTH_LOGIN_ROLES"
                :key="role.value"
                type="button"
                class="auth-step__role-option"
                :class="{ 'auth-step__role-option--selected': selectedRole === role.value }"
                role="radio"
                :aria-checked="selectedRole === role.value"
                @click="selectedRole = role.value"
            >
                <span class="auth-step__radio" aria-hidden="true">
                    <span v-if="selectedRole === role.value" class="auth-step__radio-dot" />
                </span>
                <span class="auth-step__role-label">{{ role.title }}</span>
            </button>
        </div>

        <v-btn
            block
            color="primary"
            class="text-none app-btn-primary"
            :disabled="selectedRole === null"
            elevation="0"
            @click="submitRole"
        >
            Continue
        </v-btn>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { AUTH_LOGIN_ROLES } from '~/config/auth-roles'

const emit = defineEmits<{
    roleSelected: [role: number]
}>()

const selectedRole = ref<number | null>(null)

function submitRole() {
    if (selectedRole.value !== null) {
        emit('roleSelected', selectedRole.value)
    }
}
</script>

<style scoped>
.auth-step__title {
    margin: 0 0 20px;
}

.auth-step__role-options {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-bottom: 28px;
}

.auth-step__role-option {
    display: flex;
    align-items: center;
    gap: 14px;
    width: 100%;
    min-height: 52px;
    padding: 14px 16px;
    text-align: left;
    border: 1px solid rgb(var(--v-theme-stroke));
    border-radius: 10px;
    background: rgb(var(--v-theme-surface));
    cursor: pointer;
    transition: background-color 0.15s ease, border-color 0.15s ease;
}

.auth-step__role-option:hover:not(.auth-step__role-option--selected) {
    background: #fafafa;
}

.auth-step__role-option:focus-visible {
    outline: 2px solid rgb(var(--v-theme-primary));
    outline-offset: 2px;
}

.auth-step__role-option--selected {
    background: #f3f4f6;
    border-color: #d1d5db;
}

.auth-step__radio {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 20px;
    height: 20px;
    border: 2px solid #d1d5db;
    border-radius: 50%;
    background: rgb(var(--v-theme-surface));
}

.auth-step__role-option--selected .auth-step__radio {
    border-color: rgb(var(--v-theme-primary));
}

.auth-step__radio-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: rgb(var(--v-theme-primary));
}

.auth-step__role-label {
    font-family: Inter, sans-serif;
    font-weight: 500;
    font-size: 15px;
    line-height: 1.4;
    color: rgb(var(--v-theme-heading));
}

</style>
